export enum Item_DATA_SECTION_TYPES {
    DETAILS = 'Details',
    COMMENTS = 'Comments',
    REMINDERS = 'Reminders',
    HISTORY = 'History',
    TIME_TRACKING = 'Time_Tracking',
    ATTACHMENTS = 'Attachments',
}
